// Fetch and process pending accounts from the backend

import { createContext, useContext, useState } from 'react';
import api from '../services/api';

const PendingAccountContext = createContext();

export const usePendingAccount = () => useContext(PendingAccountContext);

export const PendingAccountProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPendingAccounts = async () => {
        try {
            const response = await api.get('account/pending-verification/');
            if (response.status === 200) {
                const response_data = response.data;
                return response_data.account_list;
            } else {
                setError(response.data.details);
            }
        } catch (error) {
            setError(error.response.data.details);
        } finally {
            setLoading(false);
        }
    }

    const accountVerification = async (accountId, remarks, status, customData = {}) => {
        try {
            const payload = {
                status: status,
                remarks: remarks
            };
            
            console.log('Received customData:', customData);
            
            // Add optional fields if they exist in customData
            if (customData.hasOwnProperty('total_user_slots') && customData.total_user_slots !== null && customData.total_user_slots !== '') {
                payload.total_user_slots = customData.total_user_slots;
            }
            if (customData.hasOwnProperty('expiry_date') && customData.expiry_date !== null && customData.expiry_date !== '') {
                payload.expiry_date = customData.expiry_date;
            }
            
            console.log('Final payload:', payload);
            const response = await api.patch(`account/verification/${accountId}/`, payload);
            return response
        } catch (error) {
            setError(error.response?.data?.details || error.message);
            throw error;
        }
    }


    const value = {
        fetchPendingAccounts,
        accountVerification
    };

    return (
        <PendingAccountContext.Provider value={value}>
            {children}
        </PendingAccountContext.Provider>
    );
}           

export default PendingAccountContext;